
import React from 'react';
import Box from '@mui/material/Box';
import {Copyright, FooterLink, FooterSection} from "./Footer.styles";
import {Grid} from "@mui/material";

export const Footer = () => {

    return (
        <FooterSection>
            <Grid
                container
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                alignItems="center"
                spacing={1}
                wrap="wrap"
            >
                <Grid item xs={12} sm="auto">
                    <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                        <FooterLink to="/security">Security</FooterLink>
                        <FooterLink to="/status">Status</FooterLink>
                        <FooterLink to="/contactus">Contact Us</FooterLink>
                        <FooterLink to="/privacy">Privacy</FooterLink>
                        <FooterLink to="/terms">Terms</FooterLink>
                    </Box>
                </Grid>
                <Grid item xs={12} sm="auto">
                    <Copyright>
                        &copy; {new Date().getFullYear()} Data Axle. All rights reserved.
                    </Copyright>
                </Grid>
            </Grid>
        </FooterSection>
    );
}

